import React from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { Button } from '@tmap/mmm-style-guide/src/Button';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Add } from '@tmap/mmm-style-guide/src/Icon';
import { ImageList } from '@tmap/mmm-style-guide/src/ImageList';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { useTheme } from '@tmap/mmm-style-guide/src/Theming';
import { useMediaQuery } from '@tmap/mmm-style-guide/src/useMediaQuery';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';

import PinnedPost from './pinnedPost';

const StyledImageList = styled(ImageList)(() => ({
  overflowY: 'visible',
  '.MuiBox-root, .MuiImageListItem-quilted, .react-player__preview': {
    borderRadius: '8px',
    overflow: 'clip',
  },
  '.MuiImageListItem-root span': {
    minHeight: '100%',
  },
}));

function PinnedContent(props) {
  const {
    locationText,
    posts,
    handleOpen,
    showPostButton = true,
    pageId,
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const description = <Typography variant='body2' sx={{ marginBottom: 2 }}>Get a feel for what {locationText} is all about from the community&apos;s locals who know best.</Typography>;
  const header = <Typography component='h3' variant='h6' sx={{ marginBottom: 1 }}>{locationText} Community Feed</Typography>;
  const postText = isMobile ? 'Post' : 'Submit a Post';
  const postButton = handleOpen ? (
    <Button
      id='post'
      variant='contained'
      color='inverted'
      onClick={handleOpen}
      sx={{ boxShadow: 'none', width: 'max-content' }}
      startIcon={<Add />}
    >
      {postText}
    </Button>
  ) : (
    null
  );

  if (isMobile) {
    return (
      <>
        <Grid item xs>
          <Typography component='h3' variant='h6' sx={{ marginBottom: 1 }}>Community Feed</Typography>
        </Grid>
        {handleOpen && showPostButton && (
          <Grid item sx={{ textAlign: 'right' }}>
            {postButton}
          </Grid>
        )}
        <Grid item xs={12}>
          {description}
        </Grid>
        <Grid item xs={12}>
          <Swiper
            slidesPerView='auto'
            spaceBetween={12}
            pagination={{
              clickable: true,
            }}
            centeredSlides
            modules={[Pagination]}
            className='swiper'
          >
            {posts.map((post, i) => (
              <SwiperSlide key={`contribution-slide-${post._id}`}>
                <PinnedPost
                  key={`pinned-post-${post._id}`}
                  post={post}
                  placementId={`pinned-post-${i}`}
                  pageId={pageId}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Grid>
      </>
    );
  }

  return posts.length === 1 ? (
    <>
      <Grid item xs={6}>
        {header}
        {description}
        {handleOpen && showPostButton && postButton}
      </Grid>
      <Grid item xs={6}>
        <StyledImageList
          variant='quilted'
          cols={1}
          rows={2}
        >
          <PinnedPost
            cols={1}
            rows={1}
            post={posts[0]}
            placementId='pinned-post-0'
            pageId={pageId}
            sx={{ borderRadius: '8px', height: '100%' }}
          />
        </StyledImageList>
      </Grid>
    </>
  ) : (
    <>
      <Grid item sm={8}>
        {header}
      </Grid>
      {(handleOpen && showPostButton) ? (
        <Grid item xs sx={{ display: 'flex', justifyContent: 'end' }}>
          {postButton}
        </Grid>
      ) : (
        null
      )}
      <Grid item xs={12}>
        {description}
      </Grid>
      {posts.length > 0 ? (
        <Grid item xs sx={{ paddingTop: 0 }}>
          <StyledImageList
            variant='quilted'
            cols={2}
            rowHeight={175}
            sx={{ width: '100%', marginTop: 0 }}
          >
            {posts.map((post, i) => (
              <PinnedPost
                key={`pinned-post-${post._id}`}
                cols={1}
                rows={posts.length % 2 === 1 && i >= posts.length - 2 ? 1 : 2}
                post={post}
                placementId={`pinned-post-${i}`}
                pageId={pageId}
              />
            ))}
          </StyledImageList>
        </Grid>
      ) : (
        null
      )}
    </>
  );
}

export default PinnedContent;
